import { LeadWizard } from "../components/LeadWizard";

const ContactHeader = () => (
    <section className="relative pt-36 sm:pt-44 pb-2">
        <div
            className="pointer-events-none absolute inset-0 opacity-[0.04]"
            style={{
                backgroundImage:
                    "linear-gradient(#000 1px, transparent 1px), linear-gradient(90deg, #000 1px, transparent 1px)",
                backgroundSize: "64px 64px",
            }}
        />
        <div className="relative max-w-5xl mx-auto px-5 sm:px-8">
            <span className="font-mono text-xs tracking-[-0.01em] text-black/60 border border-black/15 rounded-full px-3.5 py-1.5 inline-flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-neon animate-pulse" />
                CONTACT US
            </span>
            <h1
                data-testid="contact-headline"
                className="font-mono tracking-[-0.01em] text-black font-semibold leading-[1.05] text-4xl sm:text-5xl lg:text-6xl mt-6 max-w-3xl"
            >
                Let's build your AI operation.
            </h1>
            <p className="font-body text-base sm:text-lg text-black/70 max-w-2xl mt-6 leading-relaxed">
                Share a few details about your business and biggest bottleneck.
                We'll get back to you with a tailored plan.
            </p>
        </div>
    </section>
);

export default function Contact() {
    return (
        <main data-testid="contact-page">
            <ContactHeader />
            <LeadWizard />
        </main>
    );
}
